export default __webpack_public_path__ + "src/assets/WideOrbit.jpg";